import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isEqual } from 'lodash';
import { finalize } from 'rxjs/operators';

import { ReportService } from '../../../core/api/report.service';
import { ReportConfig } from '../../../shared/models/report-config.model';
import { ToastLevel } from '../../../shared/models/toast-message.module';
import { ToastService } from '../../../shared/services/toast.service';
import { SpinnerService } from '../../../shared/spinner/spinner.service';

@Component({
  selector: 'fc-report-config-page',
  templateUrl: './edit-report-config-page.component.html',
  styleUrls: ['./edit-report-config-page.component.scss'],
})
export class EditReportConfigPageComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  configForm: FormGroup = this.formBuilder.group({
    config: new FormControl('', [Validators.required]),
    methodology: new FormControl('', [Validators.required]),
    reportType: new FormControl('', [Validators.required]),
  });
  reportConfig: ReportConfig;
  configId?: number;
  fakeForm: UntypedFormGroup;
  previewConfig: ReportConfig = new ReportConfig({ config: [] });

  constructor(
    readonly formBuilder: FormBuilder,
    readonly route: ActivatedRoute,
    readonly reportService: ReportService,
    readonly toastService: ToastService,
    readonly router: Router,
    readonly spinnerService: SpinnerService
  ) {
    this.configId = this.route.snapshot.params.id;
  }

  ngOnInit() {
    this.fakeForm = this.formBuilder.group({});
    if (this.configId) {
      this.reportService.getReportConfigById(this.configId).subscribe({
        next: (config: ReportConfig) => {
          this.setConfigData(config);
        },
      });
    }
  }

  setConfigData(config: ReportConfig) {
    this.reportConfig = config;
    this.configForm.controls.methodology.setValue(config.methodology, {
      emitEvent: false,
    });
    this.configForm.controls.reportType.setValue(config.reportType, {
      emitEvent: false,
    });
    this.configForm.controls.config.setValue(JSON.stringify(config.config, undefined, 4), {
      emitEvent: false,
    });
  }

  saveConfig(): void {
    let updateConfig = new ReportConfig({
      config: JSON.parse(this.configForm.value.config),
      methodology: this.configForm.value.methodology,
      reportType: this.configForm.value.reportType,
      version: this.reportConfig.version,
    });
    this.reportService
      .saveReportConfig(updateConfig)
      .pipe(finalize(() => this.spinnerService.hide()))
      .subscribe({
        next: () => {
          this.toastService.sendMessage('Question Config Updated', ToastLevel.SUCCESS);
          this.router.navigate(['admin', 'manage-report-config']);
        },
        error: err => {
          this.toastService.sendMessage(`Error updating email template: ${err}`, ToastLevel.WARN);
        },
        complete: () => {},
      });
  }

  getPreviewConfig() {
    if (
      this.configForm?.value.config &&
      !isEqual(this.previewConfig.config, JSON.parse(this.configForm.value.config))
    ) {
      this.previewConfig = new ReportConfig({ config: JSON.parse(this.configForm.value.config) });
    }
    return this.previewConfig;
  }
}
